var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('card', {
    attrs: {
      "margin": 0,
      "flat": "",
      "outlined": "",
      "hideTitle": true,
      "subtitle": "Name"
    }
  }, [_c('v-form', {
    model: {
      value: _vm.isValid,
      callback: function callback($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('v-row', {
    staticClass: "pt-2 pr-2 pl-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    class: _vm.$vuetify.breakpoint.mdAndUp ? 'mr-3' : '',
    attrs: {
      "label": _vm.$t('components.partner.PartnerReportDetail.PartnerReportUpdateReportDialog.report.firstName'),
      "flat": "",
      "outlined": ""
    },
    model: {
      value: _vm.reportDto.firstName,
      callback: function callback($$v) {
        _vm.$set(_vm.reportDto, "firstName", $$v);
      },
      expression: "reportDto.firstName"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    class: _vm.$vuetify.breakpoint.mdAndUp ? 'ml-3' : '',
    attrs: {
      "label": _vm.$t('components.partner.PartnerReportDetail.PartnerReportUpdateReportDialog.report.lastName'),
      "flat": "",
      "outlined": ""
    },
    model: {
      value: _vm.reportDto.lastName,
      callback: function callback($$v) {
        _vm.$set(_vm.reportDto, "lastName", $$v);
      },
      expression: "reportDto.lastName"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('components.partner.PartnerReportDetail.PartnerReportUpdateReportDialog.report.companyName'),
      "flat": "",
      "outlined": ""
    },
    model: {
      value: _vm.reportDto.companyName,
      callback: function callback($$v) {
        _vm.$set(_vm.reportDto, "companyName", $$v);
      },
      expression: "reportDto.companyName"
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }